<div class="verify-wrap" [id]="eleID">
  <div class="drag-progress" [id]="slideProEleID" [ngStyle]="slideProStyle"></div>
  <span class="drag-btn" [id]="slideBtnID" [ngStyle]="slideBtnStyle">
    <i nz-icon nzIconfont="icon_huadong" *ngIf="!slideFinishState"></i>
    <i nz-icon nzIconfont="icon_success" style="color: #76cc20" *ngIf="slideFinishState"></i>
  </span>
  <span class="fix-tips" [id]="slideFixTipsEleID">
    {{ initText }}
  </span>
  <span class="verify-msg" [id]="slideSucMsgEleID" [ngStyle]="slideSuccessMessageStyle">
    {{ sucessText }}
  </span>
</div>
